import http from "../axios";

let apiV1SponsoredAds = {
	baseUrl: '/api/v1/sponsored-ads',
	createImpression: async (dto) => {
		return await http.post(`${apiV1SponsoredAds.baseUrl}/impressions`, dto);
	},
	createClick: async (dto) => {
		return await http.post(`${apiV1SponsoredAds.baseUrl}/clicks`, dto);
	},
	createContinue: async (dto) => {
		return await http.post(`${apiV1SponsoredAds.baseUrl}/continues`, dto);
	}
}

export  { apiV1SponsoredAds }
